import { TreeNode } from "primeng/api";
import { CostCenterTurnover } from "../models/company-earnings.model";

export function mapCostCenterTurnoversToTreeNodes(
  items: CostCenterTurnover[] | null | undefined,
  opts?: { expandAll?: boolean }
): TreeNode[] {
  const expandAll = opts?.expandAll ?? false;

  const mapOne = (x: CostCenterTurnover): TreeNode => {
    const childrenArray = x.children ?? [];          // null/undefined -> []
    const mappedChildren = childrenArray.map(mapOne);

    return {
      key: x.costCenterId,                           
      data: {
        costCenterId: x.costCenterId,
        name: x.name,
        actualSales: x.actualSales,
        targetSales: x.targetSales,
        difference: x.difference,
      },
      children: mappedChildren.length ? mappedChildren : undefined,
      leaf: mappedChildren.length === 0,
      expanded: expandAll,
    };
  };

  return (items ?? []).map(mapOne);
}